import React from 'react';
import {InputNumber} from "primereact/inputnumber";
import {Dialog} from "primereact/dialog";
import {SwatchesPicker} from 'react-color';
import getLabel from '../../services/LinkagesDataLayer/labels';
import Slider from '@material-ui/core/Slider';

function hexToRGB(hex, alpha) {


    if (!hex) {
        return `rgba(255,255,255,${alpha || 1})`;
    }

    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    return `rgb(${r}, ${g}, ${b})`;
}

const colorDivStyle = {
    padding: '5px',
    borderRadius: '1px',
    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
    display: 'block',
    cursor: 'pointer',
    width: '60%',
    height: '40px',
}

export default class ModalLegendaRendaIbge extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            currentEditing: null,
            index: -1,
            error: null,
            colorRanges: [],
            color: '#ffffff',
            display_color_picker: false,
            display_color_picker_paleta: false,
            fillOpacity: 0.5,
        };
    }


    colors = [
        [
            '#330000',
            '#660000',
            '#990000',
            '#CC0000',
            '#FF0000',
            '#FF6666',
            '#FFB3B3',
        ],
        [
            '#000000',
            '#1A1A1A',
            '#333333',
            '#4D4D4D',
            '#666666',
            '#999999',
            '#CCCCCC',
        ],
        [
            '#000033',
            '#000066',
            '#003399',
            '#0066CC',
            '#0099FF',
            '#66CCFF',
            '#CCE5FF',
        ],
        [
            '#332B00',
            '#665500',
            '#997F00',
            '#CCAA00',
            '#FFD700',
            '#FFE866',
            '#FFF5B3',
        ],
        [
            '#002200',
            '#004400',
            '#006600',
            '#228B22',
            '#33CC33',
            '#66FF66',
            '#B3FFB3',
        ],
        [
            '#1A0033',
            '#330066',
            '#4B0082',
            '#6600CC',
            '#9933FF',
            '#CC99FF',
            '#E5CCFF',
        ],
        [
            '#1A0D00',
            '#331A00',
            '#4D2600',
            '#663300',
            '#996633',
            '#CC9966',
            '#E5CCB3',
        ]
    ];

    timeout = null;

    componentDidMount() {
        console.log(this.props.colorRanges);
    }

    displayColorPicker = () => {
        this.setState({
            ...this.state,
            display_color_picker: !this.state.display_color_picker
        });
    }

    validateOverlap = () => {
        let ranges = this.props.colorRanges;

        let error = null;

        for (let i = 0; i < ranges.length; i++) {
            let range = ranges[i];

            for (let j = 0; j < ranges.length; j++) {
                let range2 = ranges[j];

                if (i !== j) {
                    if (range.min <= range2.max && range.max >= range2.min) {
                        error = 'Os valores mínimos e máximos não podem se sobrepor.';
                    }
                }
            }

        }

        this.setState({
            ...this.state,
            error: error
        });
    }

    updateRange = async () => {

        let index = this.state.index;

        if (index === -1) {
            index = this.props.colorRanges.length;
        }

        //validate min and max
        if (this.state.currentEditing.min >= this.state.currentEditing?.max) {
            alert('O valor mínimo deve ser menor que o valor máximo.');
            return;
        }

        await this.validateOverlap();

        this.props.updateRange(this.state.currentEditing, index);

        let currentEditing = null;

        index = -1;
        if (this.state.error) {
            currentEditing = this.state.currentEditing;
            index = this.state.index;
        }

        this.setState({
            ...this.state,
            currentEditing: currentEditing,
            index: index,
        });
    }

    addRange = () => {
        this.setState({
            ...this.state,
            currentEditing: {
                min: 0,
                max: 0,
                color: '#000000'
            },
            index: -1,
        });
    }

    handleColorChange = async (e) => {

        this.setState({
            ...this.state,
            currentEditing: {
                ...this.state.currentEditing,
                color: e.hex,
                rawColor: e.hex.replace("#", "")
            },
            display_color_picker: false
        });
    }

    handleColorChangePaleta = async (e) => {
        console.log(e);
        let newColorsRanges = null;

        for (let i = 0; i < this.colors.length; i++) {
            if (this.colors[i].includes(e.hex.toUpperCase())) {
                newColorsRanges = this.colors[i];
                break;
            }
        }

        if (!newColorsRanges) {
            return;
        }

        newColorsRanges = newColorsRanges.slice().reverse();

        let newRanges = [...this.props.colorRanges];
        for (let i = 0; i < newRanges.length; i++) {
            let colorIndex = i % newColorsRanges.length;
            newRanges[i] = {
                ...newRanges[i],
                color: newColorsRanges[colorIndex],
            }
        }

        this.props.replaceRanges( newRanges);

        this.setState({
            ...this.state,
            display_color_picker_paleta: false
        });


    }

    handleClose = async (e) => {
        await this.setState({
            ...this.state,
            currentEditing: null,
            index: -1,
            display_color_picker: false,
            fillOpacity: this.props.options?.fillOpacity || 0.5,
        });

        this.props.handleClose();
    }

    getTitle = () => {
        let title = "";

        if (this.props.datalayerName) {
            title += this.props.datalayerName
        }

        if (this.props.datalayerColorProperty) {
            let colorProperty = this.props.datalayerColorProperty;
            if (this.props.datalayerColorProperty.includes("|")) {
                colorProperty = this.props.datalayerColorProperty.split("|")[1];
            }

            title += ` - ${getLabel(colorProperty)}`;
        }

        return title;

    }

    render() {

        let title = this.getTitle();

        return (<>
            <Dialog
                header="Editar Legenda"
                visible={this.props.show}
                style={{width: '50vw', marginTop: '50px'}}
                onHide={this.handleClose}
                blockScroll={true}
            >

                <div className="card" id="c-form-edit-ranges-renda-ibge">
                    <div className="card-body">
                        {this.state.error && <div className="alert alert-danger">{this.state.error}</div>}

                        {this.state.currentEditing && <React.Fragment>
                            <div id="container-form-ranges-renda-ibge" className="d-flex flex-wrap justify-content-between">


                                <div>
                                    <label htmlFor="min">Mínimo</label>
                                    <InputNumber id="min" name="min"
                                                 className="d-block"
                                                 value={this.state.currentEditing?.min}
                                                 inputStyle={{width: '99%'}}
                                                 locale="pt-BR" minFractionDigits={2}
                                                 onChange={(e) => this.setState({

                                                     currentEditing: {
                                                         ...this.state.currentEditing,
                                                         min: e.value
                                                     }
                                                 })}/>
                                </div>

                                <div>
                                    <label htmlFor="min">Máximo</label>
                                    <InputNumber id="max" name="max"
                                                 className="d-block"
                                                 inputStyle={{width: '99%'}}
                                                 locale="pt-BR" minFractionDigits={2}
                                                 value={this.state.currentEditing?.max}
                                                 onChange={(e) => this.setState({
                                                     currentEditing: {
                                                         ...this.state.currentEditing,
                                                         max: e.value
                                                     }
                                                 })}/>
                                </div>
                                <div style={{width: '15%'}}>
                                    <label htmlFor="color">Cor</label>

                                    <div style={{
                                        ...colorDivStyle,
                                        backgroundColor: hexToRGB(this.state.currentEditing?.color,  this.props.datalayerFillOpacity),
                                    }}
                                         onClick={this.displayColorPicker}>
                                        <div style={{backgroundColor: this.state.currentEditing?.color}}/>
                                    </div>
                                    {this.state.display_color_picker && <div style={{position: 'absolute', zIndex: 99999}}>
                                        <SwatchesPicker
                                            color={this.state.currentEditing?.color}
                                            onChangeComplete={this.handleColorChange}
                                            colors={this.colors}
                                        />
                                    </div>}
                                </div>
                                <div>
                                    <label htmlFor="color">&nbsp;</label>
                                    <button className="btn btn-default btn-sm btn-block" onClick={this.updateRange}>
                                        Salvar
                                        <i className="fa fa-save"/>
                                    </button>

                                </div>
                            </div>
                        </React.Fragment>}
                        <div>
                            <button className="btn btn-link btn-sm" onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    ...this.state,
                                    display_color_picker_paleta: !this.state.display_color_picker_paleta
                                });
                            }}>
                                Trocar Paleta de Cores &nbsp;
                                <i className="fa fa-palette"/>
                            </button>
                            {this.state.display_color_picker_paleta && <div style={{position: 'absolute', zIndex: 99999}}>
                                <SwatchesPicker
                                    color={this.state.currentEditing?.color}
                                    onChangeComplete={this.handleColorChangePaleta}
                                    colors={this.colors}
                                />
                            </div>}
                        </div>
                        <div style={{marginTop: '20px'}}>
                            <label htmlFor="shapeColor">Opacidade do Preenchimento</label><br/>
                            <Slider
                                value={this.props.datalayerFillOpacity}
                                aria-labelledby="discrete-slider-small-steps"
                                step={0.1}
                                marks
                                min={0.1}
                                max={1}
                                valueLabelDisplay="on"
                                onChange={this.props.onChangeOpacidadePreenchimento}
                            />
                        </div>

                        <hr/>
                        <div style={{overflowY: "auto", height: '45vh'}}>
                            <div className="float-left">
                                <button className="btn btn-success btn-sm btn-block" onClick={this.addRange}>
                                    Adicionar
                                    <i className="fa fa-plus"/>
                                </button>
                            </div>
                            <table className="table table-striped table-condensed">
                                <thead>
                                <tr>
                                    <th scope="col" colSpan="2" style={{textAlign: 'center'}}>
                                <span className="font-weight-bold text-center"
                                      style={{color: 'rgb(0, 72, 14)', fontSize: 16}}>
                                            {title}
                                </span>
                                    </th>
                                    <th className="text-right">Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.props.colorRanges?.map((item, index) => (<tr key={index} style={styles.legend}>
                                    <td style={{...styles.legend, backgroundColor: hexToRGB(item.color, this.props.datalayerFillOpacity)}}>
                                        <div style={{width: '13px', height: '13px'}}></div>
                                    </td>
                                    <td style={styles.legend}>
                                        {item.max !== Infinity && <>
                                            {Number(item.min).toLocaleString('pt-BR', {
                                                minimumFractionDigits: 0
                                            })}
                                            &nbsp;- {Number(item.max).toLocaleString('pt-BR', {
                                            minimumFractionDigits: 0
                                        })}
                                        </>}
                                        {item.max === Infinity && <>
                                            Acima de {Number(item.min).toLocaleString('pt-BR', {
                                            minimumFractionDigits: 0
                                        })}
                                        </>}
                                    </td>
                                    <td className="text-right">
                                        <button className="btn btn-default btn-sm btn-success" onClick={async (e) => {
                                            e.preventDefault();

                                            this.setState({
                                                ...this.state,
                                                currentEditing: item,
                                                index: index
                                            });
                                        }}>
                                            <i className="fa fa-edit"/>
                                        </button>
                                        &nbsp;
                                        <button className="btn btn-default btn-sm btn-danger" onClick={() => {
                                            this.props.removeRange(index);
                                            this.validateOverlap();
                                        }}>
                                            <i className="fa fa-trash"/>
                                        </button>
                                    </td>
                                </tr>))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <button className="btn btn-default btn-sm btn-block"
                            disabled={this.state.loading || this.state.error}
                            onClick={() => {
                                this.props.handleAplyColorRanges();
                                this.props.handleClose();
                            }}>
                        {this.state.loading && <i className="fa fa-spin fa-spinner"/>}
                        Aplicar
                    </button>
                </div>

            </Dialog>
        </>);
    }
}
const styles = {
    legend: {
        padding: '5px',
        margin: '4px',
    }
}
